export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS = 7_500
export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS = 100
